import { Avatar, AvatarProps } from '@chakra-ui/react';
import { FC, memo } from 'react';
import { User } from '@frx/frx-react-context';
import isEqual from 'lodash/fp/isEqual';

export interface UserAvatarProps extends AvatarProps {
  src: User['avatar'];
}

export const UserAvatar: FC<UserAvatarProps> = memo(
  ({ src, ...rest }: UserAvatarProps) => <Avatar src={src} {...rest} />,
  isEqual
);
